import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  cache: [],
  stream: null,
  progress: {
    length: null,
    total: null
  },
  purging: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
